const en = {
  'warnings.facebookAdAccount.missingPaymentMethod': 'Please add a payment method to your Facebook Ad Account',
  'warnings.socialPiper.missingPaymentMethod': 'Please add a payment method to your Social Piper account',
};

export default en;
